import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { Environment } from 'src/environments/environment.model';

import { Barn, GetBarnsResponse, UpsertBarnResponse } from '../models/barn-service.model';

@Injectable({
  providedIn: 'root',
})
export class BarnService {
  private baseUrl = `${this.env.API_BASE_URL}/service/barn/secure/barn`;

  constructor(
    private readonly http: HttpClient,
    @Inject(EnvironmentInjector) private readonly env: Environment,
  ) {}

  upsertBarn(barn: Barn): Observable<UpsertBarnResponse> {
    return this.http.post<UpsertBarnResponse>(this.baseUrl, barn, {});
  }

  deleteBarn(id: number) {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }

  getBarns(): Observable<Barn[] | HttpErrorResponse> {
    return this.http.get<GetBarnsResponse>(this.baseUrl).pipe(
      map((response: GetBarnsResponse) => response.barns),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404) {
          return of(<Barn[]>[]);
        } else {
          return throwError({ message: error.message });
        }
      }),
    );
  }
}
